import "@babel/polyfill"; //Fixes white screen bug on Android WebView API 19 and 21 (possibly more)
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// This seemed to make the /auth page hard to find. Let's try not to cache anything
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js